import React from 'react';

import dayjs from 'dayjs';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { SalesTaxForm } from './Form';
import { Button } from '../../../components';
import { generateReport, getReportData, removeReportData } from '../operations';

import './styles.scoped.css';

const SalesTaxReportForm = ({
  form,
  setForm,
  isLoadingTaxCodes,
  taxCodeOptions,
  setLoadingResults,
  setData,
  setShowResults,
}) => {
  const navigate = useNavigate();
  const handleViewResults = async () => {
    if (
      !(
        dayjs(form?.ToPerEnddate).isAfter(form?.FromPerEnddate) ||
        dayjs(form?.FromPerEnddate).isSame(form?.ToPerEnddate)
      )
    ) {
      // eslint-disable-next-line no-undef
      alert('Invalid date range. Please double check and try again.');
      return;
    }
    setLoadingResults(true);
    try {
      const response = await generateReport({
        endpoint: 'sales-tax-report',
        payload: form,
      });
      if (response.location && response.location !== '') {
        const reportData = await getReportData(response.location);
        if (reportData?.length) {
          await removeReportData(response.location);
          setLoadingResults(false);
          setData(reportData);
          setShowResults(true);
        }
      } else {
        setLoadingResults(false);
        alert('No data found matching your criteria.');
      }
    } catch (error) {
      alert('No data found matching your criteria.');
      setLoadingResults(false);
    }
    setLoadingResults(false);
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <SalesTaxForm
        form={form}
        setForm={setForm}
        handleChange={handleChange}
        isLoadingTaxCodes={isLoadingTaxCodes}
        taxCodeOptions={taxCodeOptions}
      />

      <div className="buttons-row">
        <Button
          variant="primary"
          disabled={!form?.ToPerEnddate || !form?.FromPerEnddate}
          onPress={() => handleViewResults()}
          style={{ marginRight: '20px', width: '100px' }}
          text="View"
        />

        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default SalesTaxReportForm;
